export default __webpack_public_path__ + "static/media/rebeca-modal.ff5fa722.jpg";